export enum PaymentTypeEnum {
  cash = 'Dinheiro',
  credit_card = 'Cartão de Crédito',
  debit_card = 'Cartão de Débito',
  bank_transfer = 'Transferência Bancária (TED/DOC)',
  pix = 'Pix',
  boleto = 'Boleto',
  check = 'Cheque',
  automatic_debit = 'Débito Automático'
}
